"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineImageHoverReveal = exports.ImageHoverReveal = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class ImageHoverReveal extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        const frontSrc = (0, lib_es2015_2.getAttributeOrThrowError)(this, 'front-src');
        const backSrc = (0, lib_es2015_2.getAttributeOrThrowError)(this, 'back-src');
        shadow.innerHTML = `
      <style>
        :host {
          display: inline-block;
          vertical-align: top;
          background-image: url("${backSrc}");
          background-position: center;
          background-size: cover;
        }
        
        div.front-img {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url("${frontSrc}");
          background-position: center;
          background-size: cover;
        }

        div.front-img:hover {
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }
      </style>

      <div class="front-img"></div>
    `;
    }
    connectedCallback() { }
}
exports.ImageHoverReveal = ImageHoverReveal;
const defineImageHoverReveal = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, ImageHoverReveal);
};
exports.defineImageHoverReveal = defineImageHoverReveal;
